import { c as _c } from "react/compiler-runtime";
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { getFunnelStepConfigurationTabContent } from 'modules/funnels/funnel/utils/get-funnel-step-configuration-tab-content';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import React from 'react';
import { Loader } from 'shared/components/loader';
interface StepConfigurationTabProps {
  funnelId: FunnelId;
  funnelStep: FunnelStepInterface | null;
  isMobile?: boolean;
  exitMobileTab?: () => void;
}
function StepConfigurationTab(t0) {
  const $ = _c(6);
  const {
    funnelId,
    funnelStep
  } = t0;
  if (!funnelStep) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="flex h-full items-center justify-center py-12"><Loader className="scale-150" /></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== funnelId || $[2] !== funnelStep) {
    t1 = getFunnelStepConfigurationTabContent(funnelStep, funnelId);
    $[1] = funnelId;
    $[2] = funnelStep;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <>{t1}</>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export default StepConfigurationTab;